module.exports = __webpack_public_path__ + "img/tc.b7161f13.png";